import React, { Context, createContext, FC, ReactElement, ReactNode, useState } from 'react'
import { ReactState } from '../Types/Types'

type Props = {
    children: ReactNode
}

export type AdvancedModeContextType = {
    isAdvancedMode: boolean
    setAdvancedMode: (isAdvancedMode: boolean) => void
}

const ADVANCED_MODE_KEY = 'advancedMode'

export const AdvancedModeContextProvider: FC<Props> = ({ children }: Props): ReactElement => {
    const initialValue: boolean = localStorage.getItem(ADVANCED_MODE_KEY) === 'true'
    const [isAdvancedMode, setIsAdvancedMode]: ReactState<boolean> = useState<boolean>(initialValue)

    const setAdvancedMode = (value: boolean): void => {
        setIsAdvancedMode(value)
        localStorage.setItem(ADVANCED_MODE_KEY, value.toString())
    }

    return (
        <AdvancedModeContext.Provider
            value={{
                isAdvancedMode,
                setAdvancedMode
            }}
        >
            {children}
        </AdvancedModeContext.Provider>
    )
}

const AdvancedModeContext: Context<AdvancedModeContextType> = createContext<AdvancedModeContextType>({
    isAdvancedMode: false,
    setAdvancedMode: () => {
        // eslint-disable-next-line
        console.debug('setAdvancedMode context was not defined.')
    }
})

export default AdvancedModeContext
